exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Aliva/IPCL/IPCL_SELF_CARE/src/app/components/prepaid-consumption/prepaid-consumption.component.css
// module id = ../../../../../src/app/components/prepaid-consumption/prepaid-consumption.component.css
// module chunks = 0